/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './NewStyle.scss';
import { SketchPicker } from 'react-color';

import reactCSS from 'reactcss';
import { fetchPgLayerData, getDistrictData, addSimpleStyle, fetchPgLayersList } from '../../../../../actions/district';
import ColorPicker from '../../../../ColorPicker';
// import SelectFile from '../../../../SelectFile';

import fetch from '../../../../../core/fetch';

const fastStyle = {
  marginLeft: '40px',
};

const fastStyleMargin = {
  marginTop: '20px',
};

const SimpleFill = (props) => {

  return (
    <div className="col-sm-12">
      <div style={fastStyleMargin} className="form-inline">
        <div className="col-xs-3">
          <label className="nameLabel" htmlFor="kolorWypelnienia">Kolor wypełnienia</label>
        </div>
        <div className="col-xs-1">
          <ColorPicker
            color={props.color}
            handleChange={props.handleChange}
            name="kolorLini"
          />
        </div>
      </div>
    </div>
  );
};

const LineSelector = (props) => {

  return (
    <div className="col-sm-12">
      <div style={fastStyleMargin} className="form-inline">
        <div className="col-xs-3">
          <label className="nameLabel" htmlFor="kolorLini">Kolor linii</label>
        </div>
        <div className="col-xs-1">
          <ColorPicker
            color={props.color}
            handleChange={props.handleChange}
            name="kolorLini"
          />
        </div>
      </div>
      <div style={fastStyleMargin} className="form-inline">
        <div className="col-sm-1">
          <label className="nameLabel" htmlFor="gruboscLinii">Grubość linii</label>
        </div>
        <div className="col-sm-4">
          <input
            type="range"
            name="gruboscLinii"
            className="form-input"
            min="1"
            max="20"
            onChange={(e) => props.handleChangeLineWeight(e)}
            value={props.lineWeight} />
        </div>
      </div>
      <div style={fastStyleMargin} className="row col-xs-12 form-inline">
        <div className="col-sm-1">
          <label className="nameLabel" htmlFor="lineJoin">Łączenie liniii</label>
        </div>
        <div className="col-sm-3">
          <select value={props.lineJoin} onChange={(e) => props.handleChangeLineJoin(e)} className="form-control" name="lineJoin">
            <option value="mitre">mitre</option>
            <option value="bevel">bevel</option>
            <option value="round">round</option>
          </select>
        </div>
        <div className="col-sm-1">
          <label className="nameLabel" htmlFor="lineCap">Zakończenie linii</label>
        </div>
        <div className="col-sm-3">
          <select value={props.lineCap} onChange={(e) => props.handleChangeLineCap(e)} className="form-control" name="lineCap">
            <option value="butt">butt</option>
            <option value="square">square</option>
            <option value="round">round</option>
          </select>
        </div>
      </div>
      <div style={fastStyleMargin} className="row col-xs-12 form-inline">
        <div className="col-sm-1">
          <label className="nameLabel" htmlFor="dlLinia">Długość linii (px)</label>
        </div>
        <div className="col-sm-3">
          <input value={props.strokeDashOne} onChange={(e) => props.handleChangeDashOne(e)} type="text" name="dlLinia" className="form-control" />
        </div>
        <div className="col-sm-1">
          <label className="nameLabel" htmlFor="odstepy">Długość odstępów (px)</label>
        </div>
        <div className="col-sm-3">
          <input value={props.strokeDashTwo} onChange={(e) => props.handleChangeDashTwo(e)} type="text" name="odstepy" className="form-control" />
        </div>
      </div>
      {/*<div style={fastStyleMargin} className="row col-xs-12 form-inline">
        <div className="col-sm-1">
          <label className="nameLabel" htmlFor="odstepLinii">Odstęp liniii</label>
        </div>
        <div className="col-sm-3">
          <input value={this.state.strokeOffset} onChange={(e) => this.handleChangeDashOffset(e)} type="text" name="odstepLinii" className="form-input" />
        </div>
      </div>*/}
    </div>
  );
};

const Preview = (props) => {
  return (
    <div className="col-sm-12">
      <svg className="text-center" width="600" height="140" version="1.1" xmlns="http://www.w3.org/2000/svg">
        {props.prevType === 'polygon' ? (
        <polygon
          points="50,40 550,40 550,100 50,100 50,40 300,70"
          fill={`rgba(${ props.colorWypelnienia.r }, ${ props.colorWypelnienia.g }, ${ props.colorWypelnienia.b }, ${ props.colorWypelnienia.a })`}
          stroke={`rgba(${ props.colorLinii.r }, ${ props.colorLinii.g }, ${ props.colorLinii.b }, ${ props.colorLinii.a })`}
          strokeLinejoin={props.lineJoin}
          strokeLinecap={props.lineCap}
          strokeDasharray={`${ props.strokeDashOne }, ${ props.strokeDashTwo }`}
          strokeDashoffset={props.strokeOffset}
          strokeWidth={props.lineWeight}
          x1="100" y1="30" x2="500" y2="30"
        />) : null
        }
        {props.prevType === 'line' ? (
        <line
          stroke={`rgba(${ props.colorLinii.r }, ${ props.colorLinii.g }, ${ props.colorLinii.b }, ${ props.colorLinii.a })`}
          strokeLinejoin={props.lineJoin}
          strokeLinecap={props.lineCap}
          strokeDasharray={`${ props.strokeDashOne }, ${ props.strokeDashTwo }`}
          strokeDashoffset={props.strokeOffset}
          strokeWidth={props.lineWeight}
          x1="100" y1="30" x2="500" y2="30"
        />) : null
        };
      </svg>
    </div>
  );
};

class MarkerStyle extends React.Component {
  constructor(props) {
    super(props);
    this.fillTypes = ['square', 'circle', 'triangle', 'star', 'cross', 'x', 'vertline', 'horline', 'slash', 'ackslash', 'dot', 'plus']
  }

  render() {
    return (
      <div>
        <div style={fastStyleMargin} className="col-xs-12 form-inline">
          <label className="nameLabel" htmlFor="typSzrafury">Rodzaj szrafury</label>
          <select name="typSzrafury" value={this.props.typSzrafury} onChange={this.props.handleChangeSzrafura} className="form-control">
            {this.fillTypes.map((v, i) => <option key={i} value={v}>{v}</option>)}
          </select>
        </div>
      </div>
    )
  }
}

class SimpleStyle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      colorLinii: {
        r: '241',
        g: '112',
        b: '19',
        a: '1',
      },
      colorWypelnienia: {
        r: '241',
        g: '112',
        b: '19',
        a: '1',
      },
      lineWeight: 1,
      lineJoin: 'mitre',
      lineCap: 'butt',
      strokeDashOne: '0',
      strokeDashTwo: '0',
      strokeOffset: '0',
      prevType: 'line',
      typSzrafury: 'square',
      fillType: 'simple',
    };
  }

  handleChangeLineFill = (color) => {
    this.setState({ colorLinii: color.rgb });
  };

  handleChangePolygonFill = (color) => {
    this.setState({ colorWypelnienia: color.rgb });
  };

  handleChangeLineWeight = (e) => {
    this.setState({ lineWeight: e.target.value });
  }

  handleChangeLineJoin = (e) => {
    this.setState({ lineJoin: e.target.value });
  }

  handleChangeLineCap = (e) => {
    this.setState({ lineCap: e.target.value });
  }

  handleChangeDashOne = (e) => {
    this.setState({ strokeDashOne: e.target.value });
  }

  handleChangeDashTwo = (e) => {
    this.setState({ strokeDashTwo: e.target.value });
  }

  handleChangePrevType = (e) => {
    this.setState({ prevType: e.target.value });
  }

  handleChangeFillType = (e) => {
    this.setState({ fillType: e.target.value });
  }

  handleChangeSzrafura = (e) => {
    this.setState({ typSzrafury: e.target.value });
  }


  // handleChangeDashOffset = (e) => {
  //   this.setState({ strokeOffset: e.target.value });
  // }

  handleZapisz = (e) => {
    let propsItems = {nazwa: this.props.nazwa, layer: this.props.layer}
    let mergedData = Object.assign({}, propsItems, this.state);
    this.props.addSimpleStyle(this.props.district.prefix, mergedData).then(() => this.props.onCloseNewStyle())
  }

  render() {
    return (
      <div>
        <div style={fastStyleMargin} className="col-xs-12 form-inline">
          <label className="nameLabel" htmlFor="fillType">Rodzaj wypełnienia</label>
          <select name="fillType" value={this.state.fillType} onChange={this.handleChangeFillType} className="form-control">
            <option value="simple">Proste wypełnienie</option>
            <option value="marker">Szrafura</option>
          </select>
        </div>
        {this.state.fillType === 'marker' ? <MarkerStyle /> : null}
        <SimpleFill
          handleChange={this.handleChangePolygonFill}
          color={this.state.colorWypelnienia}
        />
        <LineSelector
          color={this.state.colorLinii}
          {...this.state}
          handleChange={this.handleChangeLineFill}
          handleChangeLineWeight={this.handleChangeLineWeight}
          handleChangeLineJoin={this.handleChangeLineJoin}
          handleChangeLineCap={this.handleChangeLineCap}
          handleChangeDashOne={this.handleChangeDashOne}
          handleChangeDashTwo={this.handleChangeDashTwo}
        />
        <div className="col-xs-2 form-inline">
          <select value={this.state.prevType} onChange={this.handleChangePrevType} className="form-control">
            <option value="polygon">Poligon</option>
            <option value="line">Linia</option>
          </select>
        </div>
        <Preview {...this.state} />
      </div>
    );
  }
}

class NewStyle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdited: this.props.isNew ? this.props.isNew : false,
      styleName: this.props.styleName,
      layer: '',
      styleType: '',
    };

    this.onSelectLayerChange = this.onSelectLayerChange.bind(this);
    this.onNameChange = this.onNameChange.bind(this);
    this.onSelectStyleType = this.onSelectStyleType.bind(this);
  }

  componentDidMount = () => {
    this.setState({ layer: this.selectLayer.value }, () => this.setState({ styleType: this.selectType.value }, () => this.getLayerData(this.state.layer)));
  }

  onNameChange = (e) => {
    this.setState({
      styleName: e.target.value,
    }, () => {
      let isNameNew = false;
      this.props.styleName === this.state.styleName ? isNameNew=false : isNameNew=true;
      this.setState({ isEdited: isNameNew });
    });
  }

  onSelectLayerChange = (e) => {
    this.setState({ layer: e.target.value }, () => this.getLayerData(this.state.layer));
  }

  onSelectStyleType = (e) => {
    this.setState({ styleType: e.target.value });
  }

  getLayerData = (layerName) => {
    let currentPgLayersMetaData = [];
    this.props.pgLayersMetaData.forEach((v, i) => currentPgLayersMetaData.push(Object.keys(this.props.pgLayersMetaData[i])[0]));
    if (currentPgLayersMetaData.indexOf(layerName) === -1) {
      this.props.fetchPgLayerData(this.props.district.prefix, layerName);
    }
  };

  render() {
    return (
      <div>
        <div className="form-inline">
          <label className="nameLabel" htmlFor="nazwaStylu">Nazwa</label>
          <input className="form-control" name="nazwaStylu" value={this.state.styleName} onChange={this.onNameChange} />
          <label style={fastStyle} className="nameLabel" htmlFor="wyborWarstwy">Warstwa</label>
          <select value={this.state.layer} ref={(select) => { this.selectLayer = select; }} onChange={this.onSelectLayerChange} className="form-control" name="wyborWarstwy">
            {this.props.district.layers.map((v, i) => {
              return <option key={i} value={v.name}>{v.name}</option>;
            })}
          </select>
        </div>
        <div style={fastStyleMargin} className="form-inline">
          <label className="nameLabel" htmlFor="wyborWarstwy">Typ stylu: </label>
          <select value={this.state.styleType} ref={(select) => { this.selectType = select; }} onChange={this.onSelectStyleType} className="form-control" name="wyborWarstwy">
            <option key={0} value={'symbol'}>Symbol pojedyńczy</option>
            <option key={1} value={'unique'}>Wartość unikalna</option>
            <option key={2} value={'rule'}>Oparty o regółach</option>
          </select>
        </div>
        <div className="col-xs-12">
          {this.state.styleType === 'symbol' ? (
          <SimpleStyle
            addSimpleStyle={this.props.addSimpleStyle}
            getDistrictData={this.props.getDistrictData}
            fetchPgLayersList={this.props.fetchPgLayersList}
            onCloseNewStyle={this.props.onCloseNewStyle}
            district={this.props.district}
            nazwa={this.state.styleName}
            layer={this.state.layer}
            ref={(SimpleStyle) => {this.simple = SimpleStyle }}
          />) : null}
          {this.state.styleType === 'unique' ? <div> wartość unikalna </div> : null}
          {this.state.styleType === 'rule' ? <div> Oparta na regółach</div> : null}
        </div>
        <div className="col-xs-12">
          <button className="eventBtns btn-info" onClick={(e) => this.simple.handleZapisz(e)}>Zapisz</button>
          <button onClick={() => this.props.onCloseNewStyle()} className="eventBtns btn-default">Anuluj</button>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  pgLayersMetaData: state.district.pgLayersMetaData,
});

const NStyle = {
  fetchPgLayerData,
  fetchPgLayersList,
  getDistrictData,
  addSimpleStyle,
};

const StyleWithConnection = connect(mapState, NStyle)(NewStyle);

export default withStyles(s)(StyleWithConnection);



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/NewStyle/NewStyle.js